// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

export interface CheckoutSharedStyles {
    container?: InjectableCss;
    section?: InjectableCss;
}

const checkoutSharedStyles: CheckoutSharedStyles = {
    container: {
        css: css`
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 24px 154px;

            ${xScreen("lte", "lg")} {
                gap: 24px 135px;
            }
            
            ${xScreen("lte", "md")} {
                grid-template-columns: 1fr;
            }
        `,
    },
};

export default checkoutSharedStyles;
